<template>
  <nav
    class="navbar is-fixed-top"
    role="navigation"
    id="top-navbar"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <a @click="goToMainDomain()" class="navbar-item">
        <img
          :src="require(`@/assets/logos/${domain}.png`)"
        />
      </a>
    </div>
  </nav>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    domain() {
      return this.$store.state.domain
    }
  },
  methods: {
    goToMainDomain() {
      window.location.href = `https://${this.$store.state.domain}.com`;
    }
  }
}
</script>

<style>
.navbar-item img {
  margin-bottom: 7px;
}
.navbar-item.is-tab:hover {
  border-color: var(--verde-light-eco);
  color: #48bda6;
}
.navbar-item.navbar-item.is-tab.is-active {
  border-color: var(--verde-light-eco);
  color: #48bda6;
}
</style>
